// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__30ERS","title":"Header_title__28wtq","left":"Header_left__2xvR-","clinicName":"Header_clinicName__2bQWH"};